import { render, staticRenderFns } from "./AddProcess.vue?vue&type=template&id=46a54b8a&"
import script from "./AddProcess.vue?vue&type=script&lang=js&"
export * from "./AddProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports